import { useQuery } from '@apollo/client';
import client from '@gql/client';
import React, { useEffect, useState } from 'react';
import gqlAdverts from '@assets/gql/adverts.gql';
import gqlAttributes from '@assets/gql/adverts.attributes.gql';
import List from '@assets/tsx/list';
import { Link } from '@ambiguous/link';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import { useListContext } from '@assets/spa/context/list';
import { useRouterPath } from '@ambiguous/useRouterPath';
import { useLang } from '@ambiguous/useLang';
import { useI18n } from '@wordpress/react-i18n';
export default function Adverts({ _id, title, attributes, categories, show_empty }) {
    var _a, _b, _c;
    const [lists, setLists] = useListContext();
    const [categoryFilter, setCategoryFilter] = useState({ field: 'ID', taxonomy: 'SKELBIMUKATEGORIJA', terms: categories === null || categories === void 0 ? void 0 : categories.map(c => c.toString()) });
    const [list, setList] = useState([]);
    const [filters, setFilters] = useState({});
    const listData = lists ? (lists[_id] || {}) : {};
    const [checkedFilters, setCheckedFilters] = useState((listData === null || listData === void 0 ? void 0 : listData.checkedFilters) || []);
    const [page, setPage] = useState((listData === null || listData === void 0 ? void 0 : listData.page) || 0);
    const [filtersArr, setFiltersArr] = useState([]);
    const [path] = useRouterPath();
    const [lang] = useLang();
    const { __ } = useI18n();
    useEffect(() => {
        setLists && setLists((prev) => (Object.assign(Object.assign({}, prev), { [_id]: { checkedFilters, page, path } })));
    }, [checkedFilters, page]);
    const { data: attrData } = useQuery(gqlAttributes, {
        client,
        variables: {
            include: (attributes === null || attributes === void 0 ? void 0 : attributes.checked) || [],
            language: lang.toUpperCase()
        },
    });
    const perPage = 10;
    const { data, loading, refetch, fetchMore } = useQuery(gqlAdverts, {
        client,
        variables: {
            filters: parseFilters([...filtersArr], categoryFilter),
            size: perPage,
            offset: perPage * page,
            language: lang.toUpperCase()
        },
    });
    const totalPosts = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.skelbimai) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.offsetPagination) === null || _c === void 0 ? void 0 : _c.total) || 0;
    const totalPages = Math.ceil(totalPosts / perPage);
    useEffect(() => {
        setCategoryFilter(prev => (Object.assign(Object.assign({}, prev), { terms: categories === null || categories === void 0 ? void 0 : categories.map(c => c.toString()) })));
    }, [categories]);
    useEffect(() => {
        var _a;
        if (!attrData)
            return;
        const flat = (_a = attrData === null || attrData === void 0 ? void 0 : attrData.attributes) === null || _a === void 0 ? void 0 : _a.skelbimai;
        const hidden = (attributes === null || attributes === void 0 ? void 0 : attributes.hidden) || [];
        const labeled = flat === null || flat === void 0 ? void 0 : flat.reduce((agr, fGroup, sortOrder) => {
            var _a;
            const fEnum = fGroup.taxonomy.node.taxonomyEnumValue;
            const attributes = ((_a = fGroup === null || fGroup === void 0 ? void 0 : fGroup.terms) === null || _a === void 0 ? void 0 : _a.nodes) || [];
            const count = attributes.reduce((agr, { count }) => agr + parseInt(count || '0'), 0);
            // console.log({count,show_empty})
            if (count === 0 && show_empty !== 'yes')
                return agr;
            if (hidden.includes(fEnum))
                return agr;
            return Object.assign(Object.assign({}, agr), { [fEnum]: {
                    label: fGroup.label,
                    attributes,
                    sortOrder,
                } });
        }, {});
        setFilters(labeled);
    }, [attrData, show_empty, attributes === null || attributes === void 0 ? void 0 : attributes.hidden]);
    useEffect(() => {
        if (!attrData)
            return;
        const allAttributes = attrData.attributes.skelbimai.reduce((agr, fGroup) => [...agr, ...fGroup.terms.nodes], []);
        const checkedArr = allAttributes.filter(f => checkedFilters.includes(f.databaseId));
        const filterMap = {};
        for (const attribute of checkedArr) {
            const { taxonomyEnumValue, databaseId } = attribute;
            if (!filterMap[taxonomyEnumValue]) {
                filterMap[taxonomyEnumValue] = [];
            }
            filterMap[taxonomyEnumValue].push(databaseId.toString());
        }
        const filterVar = Object.keys(filterMap).reduce((agr, fenum) => [...agr, { taxonomy: fenum, terms: filterMap[fenum], field: 'ID' }], []);
        setFiltersArr(filterVar);
    }, [checkedFilters, attrData]);
    useEffect(() => {
        var _a;
        if (!data)
            return;
        setList(((_a = data === null || data === void 0 ? void 0 : data.skelbimai) === null || _a === void 0 ? void 0 : _a.edges) || []);
    }, [data]);
    useEffect(() => {
        refetch({
            terms: categories || [],
            filters: parseFilters([...filtersArr], categoryFilter),
        });
    }, [categories, filtersArr, categoryFilter]);
    const updateQuery = (previousResult, { fetchMoreResult }) => {
        return fetchMoreResult.skelbimai.edges.length ? fetchMoreResult : previousResult;
    };
    const itemTemplate = ({ date, id, title, uri }) => (React.createElement(Link, { href: uri, className: "ltg-list-item", key: id },
        React.createElement("div", { className: "ltg-list-item-title" }, title),
        React.createElement("div", { className: "ltg-list-item-date" },
            __("Paskelbta", 'ltg-widgets'),
            " ",
            parseDate(date))));
    const loadingTemplate = (props, index) => React.createElement(LoadingBox, { key: 'loader-' + index, style: { height: 85, marginBottom: 16 } });
    const onCheckFilters = setCheckedFilters;
    const onClickPage = (page) => {
        setPage(page);
        return fetchMore({
            variables: {
                size: perPage,
                offset: perPage * page,
                terms: categories || [],
                filters: parseFilters([...filtersArr], categoryFilter),
                language: lang.toUpperCase()
            },
            updateQuery
        });
    };
    return List({
        title,
        filters,
        itemTemplate: loading ? loadingTemplate : itemTemplate,
        list: loading ? new Array(perPage).fill({ node: 'loading' }) : list,
        loading,
        onCheckFilters,
        checkedFilters,
        page,
        setPage,
        onClickPage,
        totalPages
    });
}
function parseDate(date) {
    var _a;
    const str = new Date(date).toISOString();
    const split = str.split('T');
    const calendar_date = split[0];
    const time = (_a = split[1]) === null || _a === void 0 ? void 0 : _a.slice(0, 5);
    return `${calendar_date} ${time}`;
}
function parseFilters(filtersArr, categoryFilter) {
    var _a;
    let filters = [];
    if ((filtersArr === null || filtersArr === void 0 ? void 0 : filtersArr.length) > 0) {
        filters = filters.concat(filtersArr);
    }
    if (categoryFilter && ((_a = categoryFilter.terms) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        filters.push(categoryFilter);
    }
    if (filters.length > 0) {
        return filters;
    }
    return undefined;
}
